<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>MAX — бот оповещений</strong>
                </CCardHeader>

                <CCardBody>
                    <div class="overflow-hidden border border-gray-300 rounded-md">
                        <div class="flex items-center bg-gray-100">
                            <div class="w-2/5 py-2 font-bold pl-2">Раздел</div>
                            <div class="w-3/5 py-2 font-bold pl-2">Описание</div>
                        </div>
                        <div class="flex items-center h-10 px-2 py-4 border-t border-gray-300">
                            <div class="w-2/5 pl-2">
                                <span class="text-purple-700 cursor-pointer hover:underline" @click="$router.push('/max/chats/settings')">
                                    Настройка чатов
                                </span>
                            </div>
                            <div class="w-3/5 pl-2">
                                Группы для уведомлений о заказах и модерациях
                            </div>
                        </div>
                    </div>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    export default {
        name: 'Max'
    }
</script>
